module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video5.f35b50c7.mp4";